import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsWidgetController} from "../../standings-widget.controller";
import {STANDINGS_WIDGET} from "../../standings-widget.consts";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {SecondaryTabs} from "../../../../core/components/secondary-tabs/components/secondary-tabs";
import {observer} from "mobx-react";

export class StandingsWidgetTabsProps extends BaseProps {
  controller: StandingsWidgetController;
}

export const StandingsWidgetTabs = observer(({controller}: StandingsWidgetTabsProps) => {
  const {state} = controller;
  const {tabs, selectedTabIndex, isSmallView, shouldRenderTabs} = state;


  if(!selectedTabIndex && selectedTabIndex !== 0) {
    return null;
  }

  const tabsProps = {
    tabs,
    isSmallView,
    initialIndex: selectedTabIndex,
    onChange: (e, tab) => controller.action(STANDINGS_WIDGET.ACTION_TYPES.changeType, {index: tab.index}),
  }

  return (
    shouldRenderTabs ? <div className={classNames(styles.tabs)}>
      <SecondaryTabs {...tabsProps} />
    </div> : null
  )
})
